import { writable } from 'svelte/store';

/**
 * Current step of the form
 * @type {import('svelte/store').Writable<number>}
 */
export const step = writable(1);
export function setStep(num) {
	step.set(num);
}

/**
 * Display state of the loading spinner
 * @type {import('svelte/store').Writable<string>}
 */
export const formState = writable('');
export function setFormState(state) {
	formState.set(state);
}

/**
 * An object containing attributes for invalid fields
 * @type {import('svelte/store').Writable<{object}>}
 */
export const errors = writable({});
export function resetErrors() {
	errors.set({});
}
export function clearError(field) {
	errors.update((current) => {
		const updated = { ...current };
		delete updated[field.gf_input_name];
		return updated;
	});
}
export function setError(key, message) {
	errors.update((current) => {
		const updated = { ...current };
		updated[key] = {
			_errors: [message],
		};
		return updated;
	});
}

/**
 * An object containing attributes for invalid fields
 * @type {import('svelte/store').Writable<{object}>}
 */
export const clientSuccessValidation = writable({});
export function clearClientSuccessValidation() {
	clientSuccessValidation.set({});
}
export function setClientSuccessValidation(value) {
	clientSuccessValidation.set(value);
}
